import React, { useEffect, useRef, useState } from 'react';

import {
  Character,
} from "@dndModels";

import CharacterManageSpells from "@dndComponents/character/spells_and_abilities/manage/CharacterManageSpells";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import DandDButtonBox from '@dndComponents/DandDButtonBoxSimple';

interface Props {
  char: Character;
  enabled: boolean;
}

export default function CharacterManageSpellsButton({
  char,
  enabled,
}: Props) {
  const [open, setOpen] = useState(false);
  const [ping, setPing] = useState(false);
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = () => {
    setPing(!ping);
  }

  // eslint-disable-next-line
  useEffect(() => {
    const load = () => {
      char.subscription_holder.subscribe("Recalculated", mounted, recalculated);
      char.subscription_holder.subscribe("Spells", mounted, recalculated);
    };

    load();
  }, []);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open }
        // drawer_only
        onClose={() => {
          setOpen(false);
          char.subscription_holder.modalClosed();
        }}>
        { open &&
          <CharacterManageSpells
            character={char}
          />
        }
      </ModalOrDrawer>
    );
  }

  let needs_attention = false;
  const classes = char.spirit.classes.filter(o => o.spellcasting_ability !== "None");
  for (let i = 0; i < classes.length; ++i) {
    const char_class = classes[i];
    if (char_class.cantrips_that_count.length !== char_class.spellcasting.total_cantrips_max ||
      char_class.leveled_spells_that_count.length !== char_class.spellcasting.total_spells_prepared_max) {
      needs_attention = true;
      break;
    }
  }
  return (
    <>
      <DandDButtonBox name="Manage Spells"
        disabled={ !enabled }
        flashing={ needs_attention }
        onClick={() => {
          setOpen(true);
        }}
      />
      { renderExtras() }
    </>
  );
}